import { useMenus } from "./../utils/helper";
import "./../css/Sidebar.css";
import { useState } from "react";
import { MenuFetch, MenuView } from "./../utils/types";
import { useNavigate } from "react-router-dom";

function sortNested(data: any, outerConfig: any, innerConfig: any) {
  // sort outer array
  const sortedOuter = [...data].sort((a, b) => {
    const col = outerConfig.column;
    if (a[col] < b[col]) return outerConfig.direction === "asc" ? -1 : 1;
    if (a[col] > b[col]) return outerConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  // sort inner arrays
  return sortedOuter.map((obj) => ({
    ...obj,
    [innerConfig.array]: [...obj[innerConfig.array]].sort((a, b) => {
      const col = innerConfig.column;
      if (a[col] < b[col]) return innerConfig.direction === "asc" ? -1 : 1;
      if (a[col] > b[col]) return innerConfig.direction === "asc" ? 1 : -1;
      return 0;
    }),
  }));
}

export const Sidebar = () => {
  const outerConfig = { column: "name", direction: "asc" };
  const innerConfig = { array: "menuViews", column: "name", direction: "asc" };
  const menuGroups = sortNested(useMenus(), outerConfig, innerConfig);
  const [openGroups, setOpenGroups] = useState<{ [key: number]: boolean }>({});
  const navigate = useNavigate();

  const toggleGroup = (index: number) => {
    setOpenGroups((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const logoClick = () => {
      navigate("/dashboard");
  };


  return (
    <div id="sidebar-wrapper" className="shadow-sm overflow-auto">
      {/* Logo Area */}
      <div className="sidebar-logo-area cursor-pointer shadow-sm" onClick={logoClick}>
        <div className="w-100 h-100">
          <img src="/logo.png" alt="Vaya Technologies logo" className="w-100 h-100 object-fit-cover" />
        </div>
      </div>

      {/* Menu Groups */}
      <div className="px-1 pb-4">
        {!!menuGroups &&
          menuGroups.map((group: MenuFetch, index) => (
            <div key={index} className="mb-2">
              <button
                className="btn btn-toggle w-100 text-start fs-6"
                onClick={() => toggleGroup(index)}
              >
                {group.name}
              </button>
              {openGroups[index] && (
                <div className="mt-1">
                  {group.menuViews.map((menu: MenuView, menuIndex) => (
                    <a
                      href={menu.menuFunction}
                      className="menu-item small"
                      key={menuIndex}
                    >
                      <i className="bi bi-arrow-bar-right"></i>
                      <span>{menu.name}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
}